import React, { forwardRef, useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorS3FileManagerServices } from "../../../APIServices/Editor/editorS3FileManagerServices";
import { useParams } from "react-router";
import Swal from "sweetalert2";

const DuplicateFolder = forwardRef(({ Show, Hide, Title, sourceKey, setFileFolderUpdater }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const [checkName, setCheckName] = useState("");
  const { studyId } = useParams()
  const duplicateS3EditorFolder = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Duplicate!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Duplicate it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = { studyId };
        userData.sourceFolder = `${sourceKey?.[0]}`
        userData.newFolderName = name
        let data = await editorS3FileManagerServices.duplicateS3EditorFolder(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000));
          setName("")
          Hide()
        }
      }
    });
  };

  useEffect(() => {
    if (sourceKey?.length === 1) {
      setName((sourceKey?.[0] || "").split("/").filter(Boolean).pop() || null);
      setCheckName((sourceKey?.[0] || "").split("/").filter(Boolean).pop() || null);
    }
  }, [sourceKey]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{Title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Folder Name{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                rows={3}
                onChange={(e) => setName(e.target.value)}
                value={name}
                className={`fontSize12 ${name === checkName ? "border-danger" : ""}`}
                placeholder="Enter Folder Name"
              />
            </Form.Group>
          </Offcanvas.Body>
          <div className="text-end p-2 border-top">
            <button
              onClick={duplicateS3EditorFolder}
              disabled={buttonLoader || !name || (name === checkName)}
              title={Title}
              className="updateProfile"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Duplicating...
                </div>
              ) : (
                "Duplicate Now"
              )}
            </button>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default DuplicateFolder;
